/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const StarFilledColoredIcon = /*#__PURE__*/ createSvgIcon(
  'StarFilledColoredIcon',
  {
    ltr: {
      small: ({ id }) => (
        <>
          <path
            d="M13.63 6.32h-4L8.3 2.22a.33.33 0 00-.547-.143.35.35 0 00-.083.123L6.32 6.32h-4a.34.34 0 00-.32.32.36.36 0 00.12.27L5.5 9.49l-1.3 4.08a.33.33 0 00.23.41.358.358 0 00.3-.05L8 11.39l3.28 2.54a.33.33 0 00.46 0 .3.3 0 00.06-.31l-1.31-4.13 3.37-2.58a.32.32 0 00.08-.45.34.34 0 00-.136-.112c-.055-.024-.063-.034-.123-.028h-.051z"
            fill="#F2D049"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.723 1.525a.83.83 0 011.054.546L9.993 5.82h3.668a.635.635 0 01.317.058l.02.01.012.005a.84.84 0 01.336.275l.001.002a.82.82 0 01-.191 1.143l-3.083 2.36 1.2 3.786a.8.8 0 01-.166.81l-.009.01-.01.01a.83.83 0 01-1.131.023L8 12.022l-2.975 2.312-.012.008a.86.86 0 01-1.007-.026.832.832 0 01-.286-.885l.003-.013 1.194-3.744L1.8 7.296l-.014-.013a.86.86 0 01-.287-.645V6.61a.84.84 0 01.791-.79l.015-.001h3.652L7.2 2.029l.006-.016a.85.85 0 01.51-.485l.007-.003zM4.298 14.462h-.002l.134-.482-.132.482zM7.98 2.857L6.682 6.82H2.826l3.257 2.486-1.244 3.907 3.16-2.456 3.14 2.431-1.232-3.882 3.248-2.486H9.267L7.98 2.857zm5.75 3.96z"
            fill="#7C6919"
          />
        </>
      ),
      medium: ({ id }) => (
        <>
          <path
            d="M17.51 7.77h-5.32l-1.78-5.46a.45.45 0 00-.85 0l-1.8 5.46H2.45A.45.45 0 002 8.2a.43.43 0 00.16.35L6.66 12l-1.72 5.43a.45.45 0 00.3.56.43.43 0 00.39-.08L10 14.53l4.38 3.38a.44.44 0 00.69-.48L13.33 12l4.49-3.44a.43.43 0 00-.03-.73.501.501 0 00-.28-.06z"
            fill="#F2D049"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.7 1.547a.947.947 0 011.199.62l1.666 5.111 4.967-.003a.923.923 0 01.794.388.922.922 0 01-.216 1.294l-4.19 3.212 1.621 5.083a.931.931 0 01-1.475 1.03l-4.05-3.132-4.053 3.163a.934.934 0 01-.838.158.94.94 0 01-.643-1.177l.002-.006 1.618-5.094-4.207-3.213a.94.94 0 01.612-1.702h4.91L9.111 2.13a.94.94 0 01.58-.58l.009-.003zm7.656 6.728l-5.517.004L10 2.632 8.14 8.28H2.623l4.645 3.547-1.773 5.584 4.518-3.526 4.519 3.494-1.78-5.575 4.604-3.528z"
            fill="#7C6919"
          />
        </>
      ),
      large: ({ id }) => (
        <>
          <path
            d="M21.39 9.21h-6.65l-2.23-6.84A.56.56 0 0011.8 2a.55.55 0 00-.34.34L9.2 9.21H2.57a.55.55 0 00-.37 1l5.63 4.3-2.16 6.8a.55.55 0 00.38.69.541.541 0 00.49-.09L12 17.65l5.47 4.23a.54.54 0 00.86-.6l-2.17-6.8 5.61-4.3a.53.53 0 00.13-.75.53.53 0 00-.224-.182c-.09-.039-.079-.052-.176-.038h-.11z"
            fill="#F2D049"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.645 1.525a1.06 1.06 0 011.342.694l2.116 6.491h6.364a.655.655 0 01.271.021c.051.016.093.037.105.043l.002.001.03.014c.173.075.323.196.432.35a1.03 1.03 0 01-.242 1.445l-5.322 4.079 2.06 6.453a1.04 1.04 0 01-1.649 1.152l-5.152-3.985-5.154 4.021a1.042 1.042 0 01-.938.176 1.05 1.05 0 01-.718-1.315l.002-.006 2.053-6.465-5.342-4.08a1.05 1.05 0 01.687-1.904h6.246l2.15-6.533a1.05 1.05 0 01.649-.65l.008-.002zm.315.949a.049.049 0 00-.027.028L9.562 9.71H2.544l-.027-.003a.05.05 0 00-.033.091l.01.007 5.92 4.521-2.266 7.13a.05.05 0 00.035.062l.007.002.007.002a.04.04 0 00.036-.007L12 17.017l5.79 4.477.01.01a.04.04 0 00.05.003.04.04 0 00.014-.047l-.005-.014-2.281-7.149 5.9-4.522.012-.008a.03.03 0 00.012-.02v-.012a.03.03 0 00-.005-.01l-.005-.008a.032.032 0 00-.007-.007h-7.107l-2.346-7.195a.06.06 0 00-.071-.041z"
            fill="#7C6919"
          />
        </>
      ),
    },
  },
  false
);

export default StarFilledColoredIcon;
